<template>
  <div>
    <h1>this id daily wok</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
